    <div class="header">
        <div class="top">
            <ng-container *ngIf="selectedLift$ | async as selectedLift">
            <span class="title">{{ selectedLift.name }}</span>
            <div class="header-actions">
                <app-icon class="icon-action" library="material" variant="edit" role="button" tabindex="0"
                          [class.active]="activePanel === 'edit'" [attr.aria-expanded]="activePanel === 'edit'"
                          aria-controls="lift-edit-form" [attr.aria-label]="'generic.buttons.edit' | translate"
                          [placeholder]="'generic.buttons.edit' | translate" (click)="onEditClick()"
                          (keydown.enter)="onEditClick()" (keydown.space)="$event.preventDefault(); onEditClick()"></app-icon>
                <app-icon class="icon-action" library="material" variant="delete" type="danger" role="button" tabindex="0"
                          [attr.aria-label]="'generic.buttons.delete' | translate"
                          [placeholder]="'generic.buttons.delete' | translate" (click)="onDelete()"
                          (keydown.enter)="onDelete()" (keydown.space)="$event.preventDefault(); onDelete()"></app-icon>
                <app-icon class="icon-action" library="material" variant="add" role="button" tabindex="0"
                          [class.active]="activePanel === 'add'" [attr.aria-expanded]="activePanel === 'add'"
                          aria-controls="lift-add-tray-form" [attr.aria-label]="'admin.lifts.details.addTray' | translate"
                          [placeholder]="'admin.lifts.details.addTray' | translate" (click)="toggleAddTray()"
                          (keydown.enter)="toggleAddTray()" (keydown.space)="$event.preventDefault(); toggleAddTray()"></app-icon>
            </div>
            </ng-container>
            <app-icon class="icon-action filter-action" library="material" variant="filter_list" role="button" tabindex="0"
                      [class.active]="activePanel === 'filters'" [attr.aria-expanded]="activePanel === 'filters'"
                      aria-controls="lift-tool-filter-form" [attr.aria-label]="'admin.lifts.details.filterTrays' | translate"
                      [placeholder]="'admin.lifts.details.filterTrays' | translate" (click)="toggleFilters()"
                      (keydown.enter)="toggleFilters()" (keydown.space)="$event.preventDefault(); toggleFilters()"></app-icon>
        </div>
        <div *ngIf="activePanel === 'edit'" id="lift-edit-form" class="bottom edit-form">
            <app-input [formControl]="liftForm.controls['name']"
                       [showErrors]="liftForm.get('name').invalid && liftForm.get('name').touched"
                       placeholder="{{'admin.lifts.modal.input' | translate}}"
                       label="{{'admin.lifts.modal.input' | translate}}">
            </app-input>
            <app-icon class="icon-action" library="material" variant="save" role="button" tabindex="0"
                      [attr.aria-label]="'generic.buttons.save' | translate" [placeholder]="'generic.buttons.save' | translate"
                      (click)="onSaveClick()" (keydown.enter)="onSaveClick()"
                      (keydown.space)="$event.preventDefault(); onSaveClick()"></app-icon>
            <app-icon class="icon-action" library="material" variant="close" role="button" tabindex="0"
                      [attr.aria-label]="'generic.buttons.cancel' | translate" [placeholder]="'generic.buttons.cancel' | translate"
                      (click)="onCancelEdit()" (keydown.enter)="onCancelEdit()"
                      (keydown.space)="$event.preventDefault(); onCancelEdit()"></app-icon>
        </div>
        <app-lift-tool-filters *ngIf="activePanel === 'filters'" id="lift-tool-filter-form"
                               [form]="filterForm"
                               [allLinesLabel]="'admin.lifts.filters.allLines' | translate"
                               [lines]="lines$ | async">
        </app-lift-tool-filters>
        <form *ngIf="activePanel === 'add'" id="lift-add-tray-form" class="bottom adder" [formGroup]="trayForm">
            <app-input-switch class="add-input-service"
                              [formControl]="trayForm.get('forService')"
                              topLabel="{{'admin.lifts.details.forService' | translate}}">
            </app-input-switch>
            <app-input class="add-input-name" #trayName
                       type="number"
                       [formControl]="trayForm.get('name')"
                       [showErrors]="trayForm.get('name').invalid && trayForm.get('name').touched"
                       label="{{'admin.lifts.details.label' | translate}}"
                       placeholder="{{'admin.lifts.details.name' | translate}}">
            </app-input>
            <app-input class="add-input-slots" #trayPosition
                       type="number"
                       [formControl]="trayForm.get('slots')"
                       [showErrors]="trayForm.get('slots').invalid && trayForm.get('slots').touched"
                       label="{{'admin.lifts.details.slots' | translate}}"
                       placeholder="{{'admin.lifts.details.input' | translate}}">
            </app-input>

            <app-icon class="add-tray" library="fontawesome" variant="fa-plus" (click)="onAddTray()"></app-icon>
        </form>
    </div>
<div class="body">
    <app-loading-spinner *ngIf="isLoadingLift$ | async" class="loading-animation"></app-loading-spinner>
    <ng-container *ngIf="!(isLoadingLift$ | async) && (selectedLift$ | async) as selectedLift">
        <div class="trays" *ngIf="selectedLift.trays as trays">
            <ng-container *ngFor="let tray of trays">
                <app-tray [tray]="tray"
                          (contextmenu)="onTrayContextMenu($event, tray)"
                          (edit)="onEditTray($event)"
                          (delete)="onDeleteTray($event)"
                          (selectSlot)="onSelectSlot($event)"
                          (toggleVisibility)="onToggleTrayVisibility($event)">
                </app-tray>
            </ng-container>
        </div>
    </ng-container>
</div>
<app-context-menu #trayContextMenu [contextMenuItems]="trayContextMenuItems"></app-context-menu>

<app-confirmation-modal #removeTray
                        title="{{'admin.lifts.notifications.confirmRemoveTray' | translate }}"
                        question="{{'admin.lifts.notifications.confirmRemoveTrayQuestion' | translate: {trayName: toBeDeletedTray?.name} }}"
                        [showConfirmButton]="true"
                        [isConfirmationInProgress]="isLoading$ | async"
                        (confirmEvent)="onConfirmRemoveTray()"
                        [confirmOnlyMode]="true">
</app-confirmation-modal>

<app-confirmation-modal #removeLift
                        title="{{'admin.lifts.notifications.confirmRemoveLift' | translate }}"
                        question="{{'admin.lifts.notifications.confirmRemoveLiftQuestion' | translate: {liftName: selectedLift?.name} }}"
                        [showConfirmButton]="true"
                        [isConfirmationInProgress]="isLoading$ | async"
                        (confirmEvent)="onConfirmRemoveLift()"
                        [confirmOnlyMode]="true">
</app-confirmation-modal>

<app-confirmation-modal #changeVisibilityTray
                        title="{{'admin.lifts.notifications.confirmChangeVisibilityTray' | translate }}"
                        question="{{'admin.lifts.notifications.confirmChangeVisibilityTrayQuestion' | translate: {trayName: toChangeVisibilityTray?.name} }}"
                        [showConfirmButton]="true"
                        [isConfirmationInProgress]="isLoading$ | async"
                        (confirmEvent)="onConfirmChangeVisibilityTray()"
                        [confirmOnlyMode]="true">
</app-confirmation-modal>

<app-tool-modal [title]="'admin.lifts.toolModal.title' | translate"
                [isLoading]="isLoadingTools$ | async"
                [tools]="(tools$ | async)">
</app-tool-modal>

